export enum SessionMessageType {
  REQUEST_SESSION = 'REQUEST_SESSION',
  SESSION_RESPONSE = 'SESSION_RESPONSE',
  CHECK_ACTIVE_SESSIONS = 'CHECK_ACTIVE_SESSIONS',
  ACTIVE_SESSION_RESPONSE = 'ACTIVE_SESSION_RESPONSE'
}
